import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from "react";
import { translate } from '@haldor/ui';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Moment from "moment";
import { getSchoolDetails, updateSchoolType } from "actions/schools";
import { getActiveSchool } from 'helpers/localstorage';
import SectionTitle from 'components/Presentation/SectionTitle';
import { DataList, Expandable } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { Flex, Skeleton, Menu, Icon, TooltipMenu, Button, getActiveLanguage } from '@haldor/ui';
import { setActiveSchool } from 'actions/user';
import User from '_class/User';
import swal from "sweetalert2";
import { createExportAssessmentForSchoolId } from "actions/assessments";

var ExportAssessmentForSchool = /*#__PURE__*/function (_Component) {
  _inherits(ExportAssessmentForSchool, _Component);

  var _super = _createSuper(ExportAssessmentForSchool);

  function ExportAssessmentForSchool(props) {
    var _this;

    _classCallCheck(this, ExportAssessmentForSchool);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var schools = [];

      _this.props.currentUser.schools.forEach(function (school) {
        if (_this.userSchoolAdmin(school.id)) {
          schools.push({
            title: school.title,
            id: school.id,
            type: school.type,
            typeLocalizes: _this.props.translate(school.type),
            typeOfSchools: [{
              id: 1,
              type: "PRESCHOOL"
            }, {
              id: 2,
              type: "COMPULSORY_SCHOOL"
            }, {
              id: 3,
              type: "UPPER_SECONDARY_EDUCATION"
            }, {
              id: 4,
              type: "ADULT_EDUCATION"
            }]
          });
        }
      });

      var school = _this.props.school;

      _this.setState({
        loading: false,
        schools: schools,
        school: school
      });
    });

    _defineProperty(_assertThisInitialized(_this), "userSchoolAdmin", function (schoolId) {
      if (_this.props.currentUser.roles != null && _this.props.currentUser.roles.length > 0) {
        var schoolAdministrator = _this.props.currentUser.roles.find(function (role) {
          return role.roleId.toUpperCase() == "SCHOOL_ADMINISTRATOR" && role.referenceId == schoolId || role.roleId.toUpperCase() == "SYSADMIN";
        });

        if (schoolAdministrator != null) {
          return true;
        }
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "createAssessmentForSchoolId", function (schoolId) {
      console.log(schoolId);
      swal.fire({
        title: _this.props.translate('export-assessment'),
        text: _this.props.translate('admin-export-assessment-confirm-text'),
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: _this.props.translate('Cancel')
      }).then(function (result) {
        console.log(_this.props);
        console.log(schoolId);

        if (result.value != null) {
          _this.props.createExportAssessmentForSchoolId(schoolId);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderSchoolRow", function (school) {
      var dropdownTrigger = /*#__PURE__*/React.createElement("div", {
        className: "dropdown--trigger"
      }, school.typeLocalizes, " ", /*#__PURE__*/React.createElement(Icon, {
        name: "Chevron"
      }));
      return /*#__PURE__*/React.createElement(RowItem, {
        key: school.id
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('name')
      }, school.title), /*#__PURE__*/React.createElement(RowCell, null, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginTop: 5
        },
        onClick: function onClick() {
          return _this.createAssessmentForSchoolId(school.id);
        }
      }, _this.props.translate('export-assessment'))));
    });

    Moment.locale(getActiveLanguage());
    _this.state = {
      loading: true,
      school: [],
      schools: [],
      typeOfSchools: [{
        id: 1,
        type: "PRESCHOOL"
      }, {
        id: 2,
        type: "COMPULSORY_SCHOOL"
      }, {
        id: 3,
        type: "UPPER_SECONDARY_EDUCATION"
      }, {
        id: 4,
        type: "ADULT_EDUCATION"
      }]
    };
    return _this;
  }

  _createClass(ExportAssessmentForSchool, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var user = new User(this.props.currentUser);
      var activeSchool = getActiveSchool(this.props.currentUser.id);

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", {
          className: "single-section"
        }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(Skeleton, null)), /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
          style: {
            flex: 1
          }
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Skeleton, null)))));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "single-section"
      }, /*#__PURE__*/React.createElement(DataList, {
        data: this.state.schools,
        renderRow: this.renderSchoolRow,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("h3", {
            style: {
              textAlign: 'center'
            }
          }, _this2.props.translate('no-results'));
        }
      }));
    }
  }]);

  return ExportAssessmentForSchool;
}(Component);

_defineProperty(ExportAssessmentForSchool, "contextTypes", {
  router: PropTypes.object
});

function mapStateToProps(state, ownProps) {
  return {
    languages: state.Languages.languages,
    translate: translate(state.Languages.translations),
    tenant: state.user.tenant,
    currentUser: state.user.currentUser,
    school: state.School.active
  };
}

export default connect(mapStateToProps, {
  setActiveSchool: setActiveSchool,
  getSchoolDetails: getSchoolDetails,
  updateSchoolType: updateSchoolType,
  createExportAssessmentForSchoolId: createExportAssessmentForSchoolId
})(ExportAssessmentForSchool);